import React, { useEffect, useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { GetFirstStepsAPI } from '../../../api/API';
import TutorialsBanner from '../../../components/tutorial-help/TutorialsBanner';
import TeamTutorialBanner from '../components/TeamTutorialBanner';
import { useGuidedTour } from '../../../components/guided-tour/GuidedTourContext';
import TOUR_SCRIPTS from '../../../components/guided-tour/tourScripts';
import shell from '../SetupWizard.module.css';
import styles from './steps.module.css';
import local from './DoneScreen.module.css';
import ReadyScreen from './ReadyScreen';

const ICONS = {
  patient: PersonAddAltIcon,
  appointment: CalendarMonthIcon,
  attend: MedicalServicesOutlinedIcon,
  payment: PaymentsOutlinedIcon,
  statistics: InsertChartOutlinedIcon,
};

/**
 * Fim da configuração: aparece uma vez só, ao concluir. O botão para começar o guia
 * vem logo abaixo do título, grande e sem precisar rolar; o roteiro (os itens do card
 * Primeiros passos que têm roteiro, em FirstSteps.php) fica abaixo, como prévia. Por
 * ora não há atalho para pular o guia. Quem escolheu
 * "Tenho equipe" vê também o tutorial de equipe (sem pedir convite agora).
 * Quem ganhou os exemplos da área vê a tela "Pronto" (ReadyScreen) no lugar desta.
 */
function DoneScreen({ data }) {
  const tour = useGuidedTour();
  const [steps, setSteps] = useState([]);
  // "Dra. Ana Souza" vira "Ana": o título não serve de primeiro nome
  const firstName = (data.identity.professional_name || data.identity.person_name || '')
    .split(' ')
    .find((word) => word && !/^dra?\.?$/i.test(word)) || '';

  useEffect(() => {
    GetFirstStepsAPI((response) => {
      if (response?.success) setSteps((response.items || []).filter((item) => TOUR_SCRIPTS[item.key]));
    });
  }, []);

  const started = steps.some((item) => item.done);

  // Conta preenchida com exemplos: "Pronto" e o guia "Conheça sua conta"
  if (data.example?.seeded_at && !data.example?.removed_at) {
    return <ReadyScreen data={data} firstName={firstName} />;
  }

  return (
    <section className={`${shell.card} ${styles.done}`}>
      <span className={styles.doneIcon}><CheckIcon /></span>
      <h1 className={shell.title}>Tudo pronto{firstName ? `, ${firstName}` : ''}</h1>
      <p className={styles.doneText}>
        Sua agenda está montada e a confirmação pelo WhatsApp fica pronta antes de cada horário. Agora o guia te leva pela tela,
        passo a passo, mostrando onde clicar.
      </p>

      <div className={local.start}>
        <button type="button" className={`${shell.primaryButton} ${local.startButton}`} onClick={() => tour.start()}>
          {started ? 'Continuar o guia' : 'Começar o guia'}
          <ArrowForwardIcon />
        </button>
        <span className={local.startHint}>Leva poucos minutos e você pode parar quando quiser.</span>
      </div>

      <span className={local.previewLabel}>O roteiro do guia</span>

      <ol className={styles.nextGrid}>
        {steps.map((item, index) => {
          const Icon = ICONS[item.key] || CheckIcon;
          return (
            <li key={item.key} className={`${styles.nextCard} ${item.done ? styles.nextDone : ''}`}>
              <span className={styles.segmentIcon}><Icon /></span>
              <span className={styles.nextStep}>Passo {index + 1}</span>
              <strong className={styles.nextTitle}>{item.label}</strong>
              <span className={styles.nextText}>{item.description}</span>
              {item.done && <CheckCircleIcon className={styles.nextCheck} fontSize="small" />}
            </li>
          );
        })}
      </ol>

      {data.area?.team_mode === 'team' && (
        <div className={styles.teamTutorial}><TeamTutorialBanner /></div>
      )}
      <TutorialsBanner />
    </section>
  );
}

export default DoneScreen;
